/**
 * Shared layout for Reports / ConsolidatedReports charts:
 * grid items stretch to the row height; each card fills width and matches siblings in the row.
 */

/** MUI Grid item wrapping a chart — required for equal-height rows */
export const reportChartGridItemSx = {
  display: 'flex',
  minWidth: 0,
};

/**
 * Inner wrapper for charts in multi-column rows (e.g. xs={12} md={4}).
 * minHeight keeps a consistent row baseline when one card has less chrome.
 */
export const reportChartCellInGridSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
  minHeight: 340,
};

/** Full-width chart blocks (e.g. Budget vs BoB) */
export const reportChartCellFullWidthSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
};

/** Root Paper for standard report chart cards */
export const reportChartPaperSx = {
  px: { xs: '8px', sm: '16px' },
  py: { xs: '10px', sm: '14px' },
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  minWidth: 0,
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  backgroundColor: '#FFFFFF',
  border: '1px solid #E5E7EB',
  boxShadow: '0 4px 12px rgba(15,23,42,0.06)',
  borderRadius: '14px',
  '&:hover .report-chart-header-action': {
    opacity: 1,
  },
};

/** Consistent vertical rhythm for Revenue Intelligence sections */
export const revenueIntelligenceStackSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  width: '100%',
};

/**
 * Secondary report charts (bar / horizontal / pie / heatmap body): plot height 240–270px.
 */
export const reportChartCanvasSx = {
  flex: '0 0 auto',
  minHeight: 240,
  maxHeight: 270,
  height: 250,
  minWidth: 0,
  position: 'relative',
};

/**
 * Budget vs Business on Books — main mixed chart only: 360–400–420px (target 380).
 */
export const reportBobChartCanvasSx = {
  flex: '0 0 auto',
  minHeight: 360,
  maxHeight: 420,
  height: 380,
  minWidth: 0,
  position: 'relative',
};
